import { Typography } from '@montugroup/design-system';

export const ErxFallback = () => {
  return (
    <>
      <Typography variant="subtitle1" fontWeight={600} data-testid="customer-escript-erx-fallback">
        We&apos;re verifying your script.
      </Typography>
      <Typography>Our team will be in touch soon.</Typography>
    </>
  );
};
